import { Injectable } from '@angular/core';

import { AnalyticsBase } from '@core/analytics-legacy';

@Injectable()
export class WidgetsAnalyticsService extends AnalyticsBase {
  public readonly namespace: string = 'Widgets';
  public readonly requireViewContext: boolean = true;

  public trackEditWidgets() {
    this.track('EditWidgets');
  }

  public trackShowMore() {
    this.track('ShowMore');
  }

  public trackToggle(widgetId: string, action: 'show' | 'hide') {
    this.track('Toggle', { widgetId, action });
  }
}
